Object.defineProperty(exports, "__esModule", {
  value: true,
});

exports.urlGetValidations = "profile/validations";
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.loginAPiEndPoint = "login/login";
exports.loginAPiMethod = "POST";
exports.loginApiContentType = "application/json";

// Customizable Area Start
exports.imgPasswordInVisiblePath = "assets/ic_password_invisible.png";
exports.imgPasswordVisiblePath = "assets/ic_password_visible.png";

exports.httpPostMethod = "POST"
exports.emailLoginApiEndPoint = "bx_block_login/logins"

exports.TOKEN = "token"
exports.REFRESH_TOKEN = "refresh_token"
exports.PROFILE_KEY = "profile"
exports.COMET_AUTH_TOKEN_KEY = "comet_auth_token"
exports.REASON_PARAM_KEY = "reason"
exports.sessionExpiredReason = "session_expired"
exports.successfulLoginText = "Login successful!"
exports.errorEmailNotValid = "Email not valid.";
exports.errorPasswordNotValid = "Password not valid.";
exports.placeHolderEmail = "Email";
exports.placeHolderPassword = "Password";
exports.labelHeader = "The reason we require login";
exports.btnTxtLogin = "LOG IN";
exports.labelRememberMe = "Remember me";
exports.btnTxtSocialLogin = "LOGIN WITH SOCIAL MEDIA";
exports.labelOr = "OR";
exports.labelTitle = "Log in";
exports.forgotPassword = "Forgot password?";
exports.sessionExpiredMessage = "Your session has expired. Please log in again to continue."
// Customizable Area End
